import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {PlusIcon} from "../../common/icons";
import COLOR_THEMES, {COLORS} from "../../../colorThemes";
import {removeFromCart} from "../../../actions/actionFunctions";
import {isRecalculateSlabNeeded, recalculateSlabs} from "./parseSqftData";
import sqftShapeManager from "../../sqft/components/canvas/store/sqftShapeManager";

const SqftFeaturesPopupFeatureDeleteButton = (props) => {

  const {parentsList, parentsLists, setParentsLists, sqftFeature, activeTheme, cartItems, activeQuoteIndex, removeFromCart} = props;
  const {disabled} = sqftFeature;

  const actionButtonColor = disabled ? COLOR_THEMES[activeTheme].active : COLORS.red;

  const deleteButtonClick = () => {
    sqftFeature.disabled = !disabled;
    sqftShapeManager.setIsDisabledShapeInPopup(sqftFeature.sqftId, !disabled);

    let updatedLists;
    let updatedList = {...parentsList};

    //update parentList with new navItem
    if (isRecalculateSlabNeeded(parentsList)) {
      updatedList = recalculateSlabs(updatedList);
    }

    updatedLists = [...parentsLists];
    updatedLists[updatedLists.findIndex(list => list === parentsList)] = updatedList;
    setParentsLists(updatedLists);

    if (sqftFeature.disabled) {
      // console.log("delete sqftFeature...", sqftFeature);
      const alreadyAdded = cartItems.find(cartItem => {
        return (cartItem.sqftId === sqftFeature.sqftId) && (cartItem.currentQuote === activeQuoteIndex)
      });
      if (alreadyAdded) {
        removeFromCart(alreadyAdded);
      }
    }
  };

  return (
    <button className={"sqft-popup__feature-action" + (disabled ? " sqft-popup__feature-action--add" : " sqft-popup__feature-action--remove")}
            onClick={deleteButtonClick}>
        <span className="sqft-popup__feature-action-plus">
          <PlusIcon color={actionButtonColor}/>
        </span>
    </button>
  )
};

SqftFeaturesPopupFeatureDeleteButton.propTypes = {
  parentsList: PropTypes.object.isRequired,
  setParentsLists: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {cartItems} = store.cartState;
  const {activeQuoteIndex} = store.quotesState;
  return {
    activeTheme,
    cartItems,
    activeQuoteIndex,
  };
};
const mapDispatchToProps = {
  removeFromCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupFeatureDeleteButton)
